import {
  GenericForm,
  GenericFormLogicalField,
  genericBeforeValidate_removeDefaultKeyedError,
  ValidationEvent,
  genericValidate_textField,
  GenericTextFieldValidationOptions,
} from "../../../hooks";

import { ACountry } from "../../../model";

interface CountryFormLogicProps<Form extends GenericForm, App extends unknown> {
  required?: boolean;

  guard?: GenericTextFieldValidationOptions<Form, App>["guard"];
}
export const countryFormLogic = <Form extends GenericForm, App extends unknown>(
  props: CountryFormLogicProps<Form, App> = {}
): GenericFormLogicalField<Form, App> => ({
  presentation: props,
  validationEvents: [
    ValidationEvent.onChange,
    ValidationEvent.onBlur,
    ValidationEvent.onSubmit,
  ],
  beforeValidate: genericBeforeValidate_removeDefaultKeyedError,
  validate: genericValidate_textField({
    required: props.required,
    guard: props.guard,
    valueMustBeOneOf: (context) =>
      [ACountry.Australia, ACountry.NewZealand]
        .filter((id) => id !== ACountry.Singapore)
        .map((id) => id),
  }),
});
